export default "__VITE_ASSET__2e33b690__"